import React, { useEffect, useRef, useCallback, useState } from 'react';
import ReactDOM from "react-dom/client";
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { feedMoveToFolder, getFeeds, getFeedsByPage } from '../../../../slices/feeds/thunk';
import { createSelector } from 'reselect';
import { formatDate, formatFeedInterval } from '../../../../slices/helper.js';
import 'datatables.net-buttons-bs5';
import 'datatables.net-responsive-bs5';
import { getFeedInfo, openFeed } from '../../../../slices/feeds/thunk';
import { push } from 'redux-first-history';
import { setPreloader } from '../../../../slices/layouts/reducer';
import { getFolderInFolderThunk, getFolderRootThunk, setFolderHistory } from '../../../../slices/folder/thunk';
const $ = require("jquery");
$.DataTable = require("datatables.net-bs5");
import { Container, Input } from "reactstrap";
import { toggleFolderModal } from '../../../../slices/modals/reducer';
import { addSelectedItem, removeSelectedItem, setFolderRootPath } from '../../../../slices/folder/reducer';
// import ActionButtons from './ActionButtons';
import TableActionButtons from '../../../Folder/Components/TableActionButtons';
import { setFolderPath } from '../../../../slices/auth/menu/reducer';
import { toast } from 'react-toastify';
import { getFeedSuccess, setFeedsFirstLoad, setFeedsHasMore, setFeedsLoading, setFeedsPage } from '../../../../slices/feeds/reducer.js';
import Preloader from '../../../../Components/Common/Preloader.js';
import { calculateTablePage } from '../../../../slices/folder/helper.js';

function FeedLibraryTable() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const { pathname } = location;
  const searchParams = new URLSearchParams(location.search);
  const folderId = searchParams.get('folderId');

  const selectStates = createSelector(state => state, state => ({
    feedsLoading: state.Feed.feedsLoading,
    feedsHasMore: state.Feed.feedsHasMore,
    feedsFirstLoad: state.Feed.feedsFirstLoad,
    feedsShowLoader: state.Feed.feedsShowLoader,
    feedsPage: state.Feed.feedsPage,
    feeds: state.Feed.feeds,
    feedsErr: state.Feed.feedsErr,
    feedsErrMsg: state.Feed.feedsErrMsg,
    userList: state.Settings.userList,
    permission: state.Permission.permission,
    title: state.MenuData.title
  }))
  const {
    feedsLoading,
    feedsHasMore,
    feedsFirstLoad,
    feedsShowLoader,
    feedsPage,
    feeds,
    feedsErr,
    feedsErrMsg,
    userList,
    permission,
    title
  } = useSelector(selectStates);
  const [feedTableState, setFeedTableState] = useState([]);
  const tableRef = useRef();
  const dataTableRef = useRef(null);

  useEffect(() => {    
    if (feedsFirstLoad === false) {
      dispatch(setFeedsFirstLoad(true));     
      if (Array.isArray(feeds)) {
        setFeedTableState([...feeds].sort((a, b) => a?.modifiedDate +  b?.modifiedDate));
      }
    }
  }, [feeds, feedsFirstLoad]);

  function fetchedFeedToTable(data) {
    if (dataTableRef.current) {
      let i = 0;
      dataTableRef.current.clear();
      const orderedData = data.sort((a, b) => a?.modifiedDate +  b?.modifiedDate);
      do {
        dataTableRef.current.row.add(orderedData[i]).draw();
        i++;
      } while (i < orderedData.length);
    }
  }

  const fetchFeed = useCallback(async (pageNum, tableData) => {
    dispatch(setFeedsLoading(true));
    try {
      const resData = await dispatch(getFeedsByPage(pageNum));
      if (resData.payload.length === 0) {
        dispatch(setFeedsHasMore(false));
        dispatch(replace(window.location.href, { title: title, feeds: tableData, hasMore: false, firstLoad: false, feedsPage: pageNum }));
        return;
      }
      const feedsVar = [...tableData, ...resData.payload];
      fetchedFeedToTable(feedsVar);
      dispatch(getFeedSuccess(feedsVar));
      dispatch(replace(window.location.href, { title: title, feeds: feedsVar, hasMore: true, firstLoad: true, feedsPage: pageNum }));
    } catch (error) {
      // console.log(error);
    } finally {
      dispatch(setFeedsLoading(false));
    }
  }, []);

  let scrollTimeout;
  useEffect(() => {
    async function handleScroll() {
      if (scrollTimeout) clearTimeout(scrollTimeout);

      scrollTimeout = setTimeout(async () => {
        const scrollableHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const currentScroll = window.scrollY;

        if (currentScroll >= scrollableHeight - 100) {
          if (!feedsLoading && feedsHasMore) {
            await fetchFeed(feedsPage, (feedTableState ? feedTableState : []));
            dispatch(setFeedsPage(feedsPage + 1));
          }
        }
      }, 100);
    }

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [fetchFeed, feedsHasMore, feedsLoading, feedsPage, feedTableState]);

  useEffect(() => {
    if (feedTableState) {
      try {
        dataTableRef.current = $(tableRef.current).DataTable({
          dom: "Bfrtip",
          data: feedTableState,
          columns: [
            {
              data: null,
              title: "Feed Name",
              render: (data, type, row) => {
                if (row.hasOwnProperty('isFolder')) {
                  return `<div class="d-flex gap-3 align-items-center">
                    <div class="avatar-sm flex-shrink-0">
                      <span class="avatar-title rounded bg-light text-primary fs-3">
                        <i class="ri-folder-line"></i>
                      </span>
                    </div>
                    <a class="feed" role="button">${(row?.name || '')}</a>
                  </div>`;
                }
                switch (row.status) {
                  case 0:
                    return `<div class="d-flex gap-3 align-items-center">
                      <div class="avatar-sm flex-shrink-0">
                        <span class="avatar-title rounded bg-danger-subtle text-danger fs-3">
                          <i class="mdi mdi-rss"></i>
                        </span>
                      </div>
                      <a class="feed" role="button">${(row?.name || '')}</a>
                    </div>`;
                  case 1:
                    return `<div class="d-flex gap-3 align-items-center">
                      <div class="avatar-sm flex-shrink-0">
                        <span class="avatar-title rounded bg-info-subtle text-info fs-3">
                          <i class="mdi mdi-rss"></i>
                        </span>
                      </div>
                      <a class="feed" role="button">${(row?.name || '')}</a>
                    </div>`;
                  case 2:
                    return `<div class="d-flex gap-3 align-items-center">
                      <div class="avatar-sm flex-shrink-0">
                        <span class="avatar-title rounded bg-warning-subtle text-primary fs-3">
                          <i class="mdi mdi-rss"></i>
                        </span>
                      </div>
                      <a class="feed" role="button">${(row?.name || '')}</a>
                    </div>`;
                }
              }
            },
            {
              data: null,
              title: "Types",
              render: (data, type, row) => {
                if (row.isFolder) {
                  return ``;
                }
                if (row.type) {
                  return row.type;
                } else {
                  return "";
                }
              }
            },
            {
              data: null,
              title: "Refresh Interval",
              render: (data, type, row) => {
                if (row.interval) {
                  return formatFeedInterval(row.interval);
                } else {
                  return "";
                }
              }
            },
            {
              data: null,
              title: "Status",
              render: (data, type, row) => {
                switch (row.status) {
                  case 1:
                    return `<span class="badge bg-success-subtle text-primary fs-11 text-uppercase">
                              <i class="ri-checkbox-circle-line align-bottom"></i> Active
                          </span>`;
                  case 0:
                    return `<span class="badge bg-danger text-white fs-11 text-uppercase">
                              <i class="ri-close-circle-line align-bottom"></i> Inactive
                          </span>`;
                  case 2:
                    return `<span class="badge bg-warning-subtle text-primary fs-11 text-uppercase">
                              <i class="ri-close-circle-line align-bottom"></i> Broken
                          </span>`;
                };
                return "";
              }
            },
            {
              data: "createdDate",
              title: "Created",
              render: (data, type, row) => {
                return formatDate(data);
              }
            },
            {
              data: "modifiedDate",
              title: "Modified",
              render: (data, type, row) => {
                return formatDate(data);
              }
            },
            {
              data: null,
              title: "Created By",
              render: (data, type, row) => {
                if (row.hasOwnProperty("createdBy")) {
                  const foundUser = userList.find(item => item._id === row.createdBy);
                  if (foundUser) {
                    return foundUser.firstName + " " + foundUser.lastName;
                  } else {
                    return "";
                  }
                } else if (row.hasOwnProperty("userId")) {
                  const foundUser = userList.find(item => item._id === row.userId);
                  if (foundUser) {
                    return foundUser.firstName + " " + foundUser.lastName;
                  } else {
                    return "";
                  }
                }
              }
            },
            {
              data: null,
              title: "Action",
              orderable: false,
              render: (data, type, row) => {
                return `
                <div class="dropdown">
                  <button class="btn btn-soft-info btn-sm" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="ri-more-fill align-middle"></i>
                  </button>
                  <ul class="dropdown-menu">
                    <li><a class="dropdown-item" href="#">Rename</a></li>
                    <li><a class="dropdown-item" href="#">Duplicate</a></li>
                    <li><a class="dropdown-item" href="#">Remove</a></li>
                  </ul>
                </div>
                `
              }
            }
          ],
          responsive: true,
          columnDefs: [
            { responsivePriority: 1, targets: [1, -2] },
            { responsivePriority: 2, targets: "_all" },
            {
              targets: [-1],
              createdCell: (td, cellData, rowData, row, col) => {
                const root = ReactDOM.createRoot(td);
                let permissions = [];
                if (permission.brands[rowData.brandId].permissionsWK.includes("feedDelete")) {
                  permissions.push("feedDelete");
                }
                if (permission.brands[rowData.brandId].permissionsWK.includes("feedView")) {
                  permissions.push("feedView");
                }
                if (permission.brands[rowData.brandId].permissionsWK.includes("feedEdit")) {
                  permissions.push("feedEdit");
                }
                let table = $(td).closest('table');
                let tableApi = table.DataTable();
                root.render(<TableActionButtons rowData={rowData} viewItem={() => viewItem(rowData, tableApi)} dispatch={dispatch} permissions={permissions} type={'feed'} />);
              }
            }
          ],
          language: {
            emptyTable: 'No feeds available',
            info: 'Showing _START_ to _END_ of _TOTAL_ feeds',
            infoEmpty: 'Showing 0 to 0 of 0 feeds',
            infoFiltered: '(filtered from _MAX_ total feeds)',
            zeroRecords: "No matching feeds found"
          },
          destroy: true,
          order: [],
          // ordering: false,
          searching: false,
          paging: false,
          info: false
        });

        async function selectRow(e) {
          if ($(e.target).hasClass("feed") || $(e.target).hasClass("table-button")) {
            return;
          } else {
            let tr = $(this).closest("tr");
            if ($(tr).hasClass("child")) {
              tr = $(tr).prev();
            }
            let data = dataTableRef.current.row(tr).data();
            if (data) {
              if ($(this).hasClass("selected-row")) {
                dispatch(removeSelectedItem(data._id));
                $(this).removeClass("selected-row");
              } else {
                dispatch(addSelectedItem(data));
                $(this).addClass("selected-row");
              }
            }
          }
        }

        async function viewFeed() {
          let tr = $(this).closest("tr");
          if ($(tr).hasClass("child")) {
            tr = $(tr).prev();
          }
          let data = dataTableRef.current.row(tr).data();
          viewItem(data, dataTableRef.current);
        }

        dataTableRef.current.on("click", "tr", selectRow);
        dataTableRef.current.on("click", ".feed", viewFeed)

        return function () {
          dataTableRef.current.off("click", "tr", selectRow);
          dataTableRef.current.off("click", ".feed", viewFeed)
          dataTableRef.current.destroy();
        }
      } catch (error) {
        // console.log(error);
      }
    }
  }, [feedTableState]);

  async function viewItem(data, table) {
    if (data) {
      table.destroy();
      if (data.hasOwnProperty("isFolder")) {
        dispatch(setPreloader(true));
        dispatch(setFolderPath(data._id));
        dispatch(setFeedsHasMore(true));
        dispatch(setFeedsFirstLoad(true));
        dispatch(setFeedsPage(1));
        const feedRes = await dispatch(getFeeds());
        const feeds = [];
        if (Array.isArray(feedRes.payload)) {
          feeds.push(...feedRes.payload);
        }
        const folderPathSrc = `${pathname}?folderId=${data._id}`
        const newBreadcrumbTitle = { name: data.name, src: folderPathSrc };
        let updatedBreadcrumbTitle = [];
        if (title.length === 0) {
          let feedsPath = `/${params.client}/${params.brand}`;
          if (params.market) {
            feedsPath += `/${params.market}`;
          }
          feedsPath += '/feeds';
          updatedBreadcrumbTitle = [{ name: 'Feeds', src: feedsPath }, newBreadcrumbTitle];
        } else {
          updatedBreadcrumbTitle = [...title, newBreadcrumbTitle];
        }
        dispatch(push(folderPathSrc, { 
          feeds: feeds, 
          title: updatedBreadcrumbTitle,
          hasMore: true,
          firstLoad: true,
          feedsPage: calculateTablePage(feeds.length)
        }));
        dispatch(setPreloader(false));
      } else {
        dispatch(openFeed(data._id, params));
      }
    }
  };
  return (
    <React.Fragment>
      {feedsShowLoader ?
        <Preloader isComponentLoader={true} />
        :
        <div className='mt-2'>
          <table className='align-middle table-nowrap mb-0 table' style={{ width: "100%" }} id='feedTable' ref={tableRef}>
            <thead className='table-light'></thead>
            <tbody></tbody>
          </table>
        </div>
      }
    </React.Fragment>
  )
}

export default FeedLibraryTable;